import React from 'react'
import './preLoading.css'
function PreLoading() {
  return (
    <div>
<div class="loaderm">
    <div class="shape1"></div>
    <div class="shape2"></div>
    <div class="shape3"></div>
    <div class="shape4"></div>
</div>
{/* <div className='ggg'>
 <h6>Loading....</h6>
</div> */}
    </div>
  )
}

export default PreLoading